import type { AppSaveBarScope } from "./app-save-bar.enum";
import type { AppSaveBarState, SetSaveBarItemProps } from "./app-save-bar.type";

import { atom } from "jotai";
import { atomFamily } from "jotai-family";
import omit from "lodash/omit";

import { logSaveBar } from "./app-save-bar.helper";

export const appSaveBarAtom = atom<AppSaveBarState>({});

export const appSaveBarItemAtom = atomFamily((scope: AppSaveBarScope) =>
  atom((get) => get(appSaveBarAtom)[scope] ?? {})
);

export const setSaveBarItemAtom = atom(
  null,
  (get, set, { scope, key, value }: SetSaveBarItemProps) => {
    const prevState = get(appSaveBarAtom);
    const prevItem = prevState[scope];
    const prevValue = prevItem?.[key];

    if (value === prevValue) return;

    const newItem = { ...prevItem, [key]: value };
    logSaveBar("SET", scope, { [key]: value });
    set(appSaveBarAtom, { ...prevState, [scope]: newItem });
  }
);

export const resetSaveBarItemAtom = atom(
  null,
  (get, set, scope: AppSaveBarScope) => {
    const prevState = get(appSaveBarAtom);
    const newState = omit(prevState, scope);
    logSaveBar("RESET", scope);
    set(appSaveBarAtom, newState);
  }
);
